import EPGCategories from './EPGCategories';

export * from './EPGCategories';
export default EPGCategories;
